import { useAuthedRest } from '@/api/useAuthedRest';

import { useGraphQLMutation } from './useGraphQLMutation';
import { useGraphQLQuery } from './useGraphQLQuery';

// Admin view of a user-submitted request (RFC 016), joined to its requester by
// the `/admin/request` endpoint. Shape mirrors the API's `AdminRequestItem`.
export interface AdminRequestItem {
  id: string;
  url: string | null;
  name: string | null;
  status: 'pending' | 'done';
  createdAt: string;
  requester: { name: string; email: string } | null;
}

export function useRequests() {
  const rest = useAuthedRest();
  const { data, isLoading, error, refetch } = useGraphQLQuery<AdminRequestItem[]>({
    fetcher: (signal) => rest.request<AdminRequestItem[]>('/admin/request', { signal }),
    deps: [],
  });
  return { requests: data ?? [], isLoading, error, refetch };
}

export function useMarkRequestDone() {
  const rest = useAuthedRest();
  const { mutate, isSubmitting, error } = useGraphQLMutation<string, true>({
    mutationFn: async (id, signal) => {
      await rest.request<undefined>(`/admin/request/${id}/done`, { method: 'POST', signal });
      return true;
    },
  });
  return { markDone: mutate, isSubmitting, error };
}
